import * as Redux from 'redux'
import * as App from '../../../app'
import * as Request from '../../../request'
import * as Schedules from '../constants'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

export type DefaultAction = () => Redux.Action
export type DeleteAction = (holiday: Types.Holiday) => Redux.Action

export const addHoliday: DefaultAction = () => ({type: Constants.ADD_HOLIDAY})
export const resetHolidays: DefaultAction = () => ({type: Constants.RESET_HOLIDAYS})
export const saveHolidays: DefaultAction = () => ({type: Constants.SAVE_HOLIDAYS})
export const deleteHoliday = (holiday: Types.Holiday) => ({type: Constants.DELETE_HOLIDAY, id: holiday.id})

export type SaveHolidaysActionCreator =
  (communityIdentifier: App.SelectedCommunity, holidays: Types.Holidays) => Request.RequestAction
export const submitHolidayUpdate: SaveHolidaysActionCreator =
  (communityIdentifier: App.SelectedCommunity, holidays: Types.Holidays) =>
    Request.requestActionCreator(Constants.UPDATE_HOLIDAYS)({
      method: 'POST',
      payload: Utils.holidayUpdatePayload(holidays),
      url: `${Schedules.SERVER_RESOURCE}/${communityIdentifier}/holidays`,
    })



// WEBPACK FOOTER //
// ./src/pages/schedules/holidays/actions.ts